import { Link } from "react-router-dom";
import { UploadCloud, FileText, Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/lib/i18n";

const ITEMS = [
  ["upload", UploadCloud, ["Muat naik rakaman sedia ada", "Upload existing recordings"],
    ["Seret dan lepas fail MP3, WAV, M4A atau MP4. Fail dimampatkan dalam pelayar dan dimuat naik secara berperingkat, jadi anda boleh jeda dan sambung semula walaupun talian perlahan.", "Drag and drop MP3, WAV, M4A or MP4 files. Files are compressed in your browser and uploaded in chunks, so you can pause and resume even on a slow connection."],
    [["Fail sehingga 300 MB / 4 jam", "Files up to 300 MB / 4 hours"], ["Jeda, sambung & batal muat naik", "Pause, resume & cancel uploads"], ["Teruskan kerja lain semasa dimuat naik", "Keep working while it uploads"]]],
  ["transcript", FileText, ["Transkrip tepat, terus jadi dokumen", "Accurate transcripts, straight to documents"],
    ["MinitAI menukar audio kepada transkrip berlabel penutur dalam Bahasa Melayu, English atau campuran. Satu klik untuk menjana Minit Rasmi, Nota Kuliah atau Laporan.", "MinitAI turns audio into speaker-labelled transcripts in Malay, English or a mix of both. One click to generate Official Minutes, Lecture Notes or a Report."],
    [["Penutur dikenal pasti automatik", "Speakers identified automatically"], ["Klik ayat untuk dengar semula audio", "Click any line to replay the audio"], ["Eksport PDF, Word, PowerPoint & CSV", "Export to PDF, Word, PowerPoint & CSV"]]],
];

const Item = ({ id, Icon, title, desc, points, reverse }) => {
  const { L } = useApp();
  return (
    <article className="grid items-center gap-8 md:grid-cols-2 md:gap-14" data-testid={`upload-usp-${id}`}>
      <div className={`overflow-hidden rounded-3xl border border-slate-200 bg-[#F7EDE2] shadow-sm ${reverse ? "md:order-2" : ""}`}>
        <img src={`/landing/usp-${id}.webp`} alt={L(...title)} loading="lazy" className="aspect-[866/530] w-full object-cover transition-transform duration-500 hover:scale-[1.03]" />
      </div>
      <div>
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-violet-600 text-white"><Icon size={20} /></span>
        <h3 className="mt-5 text-2xl font-bold tracking-tight text-slate-900">{L(...title)}</h3>
        <p className="mt-3 leading-relaxed text-slate-600">{L(...desc)}</p>
        <ul className="mt-5 space-y-2.5">
          {points.map((p, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-slate-700"><Check size={18} className="mt-0.5 shrink-0 text-violet-600" />{L(...p)}</li>)}
        </ul>
      </div>
    </article>
  );
};

export const UploadUsp = () => {
  const { L } = useApp();
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-24 lg:px-8" data-testid="upload-usp-section">
      <p className="text-sm font-semibold uppercase tracking-wider text-violet-700">{L("Muat naik & Transkrip", "Upload & Transcribe")}</p>
      <h2 className="mt-3 max-w-2xl text-3xl font-extrabold tracking-tight sm:text-4xl">{L("Ada rakaman lama? Muat naik, MinitAI uruskan selebihnya.", "Got old recordings? Upload them and MinitAI does the rest.")}</h2>
      <div className="mt-12 space-y-16 md:space-y-20">
        {ITEMS.map(([id, Icon, title, desc, points], i) => <Item key={id} id={id} Icon={Icon} title={title} desc={desc} points={points} reverse={i % 2 === 1} />)}
      </div>
      <Button asChild size="lg" className="mt-14 h-12 rounded-xl bg-violet-600 px-6 hover:bg-violet-700" data-testid="upload-usp-cta">
        <Link to="/register">{L("Muat naik rakaman pertama anda", "Upload your first recording")} <ArrowRight size={16} className="ml-1" /></Link>
      </Button>
    </section>
  );
};
